import React, {useState, useEffect} from 'react';
import State from "../State";
import './LiveResults.css';
import EntityApiService from "../Entities/EntityApiService";
import ClipLoader from "react-spinners/ClipLoader";

function LiveResults({jsonServer}) {

    const [state] = useState(new State(useState(0)));
    const [ageState] = useState(new State(useState(0)));

    const service = new EntityApiService(jsonServer, state, {
        type: 'CompetitionClass',
        flavor: 'liveresults',
        modificationTypes: ['Result', 'Runner']
    });

    const ageClassService = new EntityApiService(jsonServer, ageState, {
        type: 'AgeClass',
        flavor: 'liveresults',
        modificationTypes: ['Result', 'Runner']
    });


    useEffect(() => {
        service.list()
        const interval = setInterval(() => {
            service.list();
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        ageClassService.list()
        const interval = setInterval(() => {
            service.list();
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    if (!state.result || !ageState.result) {
        return (
            <div>
                <ClipLoader loading={state.loading} size={150}/>
            </div>
        );
    }


    const classes = (state.result || []).sort((a, b) => a.order - b.order);
    const ageClasses = ageState.result;

    function runnerTimes(team) {
        return team.runners.map( r => {
            const res = r.result ? r.result[0] : null;
            if (!res)
                return '';
            return (
            <>{r.firstName + ' ' + r.lastName} {res.time} <br/></>
        )});
    }

    return (
        <div>
            <button title="Uppdatera" onClick={() => {
                service.list(false);
            }}>🔄
            </button>
            {
                state.loading ? (<ClipLoader loading={state.loading} size={20}/>) : ''
            }
            <h1>Liveresultat</h1>
            {classes.map(c => (
                    <span key={c.id+ 'a'}>
                        <a href={'#' + c.id}>{c.name}</a>
                        &nbsp;&nbsp;
                    </span>
                )
            )}
            <br/>
            {classes.map(c => {
                    if (c.name === '21 km M' || c.name === '21 km K') {
                        return '';
                    }
                    return (
                        <span key={c.id+ 't'}>
                            <a href={'#t' + c.id}>Lag {c.name}</a>
                            &nbsp;&nbsp;
                        </span>
                    )
                }
            )}
            <br/>
            {ageClasses.map(c => !c.runnerCount ? '' : (
                <span key={c.id}>
                    <a href={'#' + c.id}>{c.name}</a>
                    &nbsp;&nbsp;
                </span>
            ))}


            {classes.map((competitionClass) => {
                return (
                    <div key={competitionClass.id} className="liveresultclass">
                        <a name={competitionClass.id}/><h2>{competitionClass.name}</h2>
                        <table className="startdisplaytable">
                            <tbody>
                            {competitionClass.results.map((runner, i) => {
                                const res = runner.result ? runner.result[0] : null;
                                if (!res || res.status !== 'OK')
                                    return '';
                                const ok = res.status === 'OK';
                                return (
                                    <tr key={runner.id}>
                                        <td className="place">{ok ? i + 1 : ''}</td>
                                        <td className="liveRunnerName">{runner.firstName + ' ' + runner.lastName}</td>
                                        <td className="liveRunnerClub">{runner.club}</td>
                                        <td className="liveRunnerTime">{res.time}</td>
                                    </tr>)
                            })}
                            </tbody>

                        </table>
                    </div>

                )
            })}


            {classes.map((competitionClass) => {
                if (competitionClass.name === '21 km M' || competitionClass.name === '21 km K') {
                    return '';
                }
                return (
                    <div key={competitionClass.id} className="liveresultclass">
                        <a name={'t' + competitionClass.id}/><h2>Lag {competitionClass.name}</h2>
                        <table className="startdisplaytable">
                            <tbody>
                            {competitionClass.teamResults.map((team, i) => {
                                return (
                                    <tr key={team.id}>
                                        <td className="place">{team.hasFinished ? i + 1 : ''}</td>
                                        <td className="liveRunnerName">{team.name}</td>
                                        <td className="liveRunnerTeamMember">{runnerTimes(team)}</td>
                                        <td className="liveRunnerTime">{team.time}</td>
                                    </tr>)
                            })}
                            </tbody>

                        </table>
                    </div>

                )
            })}

            {ageClasses.map(ageClass => !ageClass.runnerCount ? '' : (
                    <div key={ageClass.id} className="liveresultclass">
                        <a name={ageClass.id}/><h2>{ageClass.name}</h2>
                        <table className="startdisplaytable">
                            <tbody>
                            {ageClass.results.map((runner, i) => {
                                const res = runner.result ? runner.result[0] : null;
                                if (!res || res.status !== 'OK')
                                    return '';
                                const ok = res.status === 'OK';
                                return (
                                    <tr key={runner.id}>
                                        <td className="place">{ok ? i + 1 : ''}</td>
                                        <td className="liveRunnerName">{runner.firstName + ' ' + runner.lastName}</td>
                                        <td className="liveRunnerClub">{runner.club}</td>
                                        <td className="liveRunnerTime">{res.time}</td>
                                    </tr>)
                            })}
                            </tbody>
                        </table>
                    </div>
            ))}

        </div>
    );
}

export default LiveResults;